import Analytics from './Google/Analytics'
import Maps from './Google/Maps'
import TagManager from './Google/TagManager'

export default {
    Analytics,
    Maps,
    TagManager,
}
